import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { supabase } from "@/lib/supabase";

type Transmissao = {
  id: number;
  url: string | null;
  titulo: string | null;
  descricao: string | null;
  scheduled_start_at: string | null;
  scheduled_end_at: string | null;
  ativo: boolean | null;
};

const fallbackImage =
  "https://readdy.ai/api/search-image?query=Football%20stadium%20night%20live%20broadcast%20dramatic%20lights%20empty%20field%20professional%20sports%20media&width=1200&height=675&seq=aovivo&orientation=landscape";

export default function AoVivoHighlight() {
  const navigate = useNavigate();

  const [transmissao, setTransmissao] = useState<Transmissao | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function carregarTransmissao() {
      setLoading(true);

      const { data } = await supabase
        .from("transmissoes")
        .select("id, url, titulo, descricao, scheduled_start_at, scheduled_end_at, ativo")
        .eq("id", 1)
        .single();

      setTransmissao(data || null);
      setLoading(false);
    }

    carregarTransmissao();

    const interval = setInterval(carregarTransmissao, 30000);

    return () => clearInterval(interval);
  }, []);

  if (loading) {
    return null;
  }

  const now = Date.now();
  const startsAt = transmissao?.scheduled_start_at
    ? new Date(transmissao.scheduled_start_at).getTime()
    : null;
  const endsAt = transmissao?.scheduled_end_at
    ? new Date(transmissao.scheduled_end_at).getTime()
    : null;
  const isWithinSchedule = (!startsAt || now >= startsAt) && (!endsAt || now <= endsAt);

  if (transmissao?.ativo === false || !transmissao?.url || !isWithinSchedule) {
    return null;
  }

  return (
    <section className="w-full py-8 md:py-12">
      <div className="w-full px-4 md:px-8">
        <div className="bg-alvinegro-black rounded-3xl overflow-hidden">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-0">
            <div className="relative aspect-video lg:aspect-auto bg-black">
              <iframe
                src={transmissao.url}
                className="w-full h-full border-0"
                allowFullScreen
                allow="autoplay; encrypted-media; picture-in-picture"
                title={transmissao.titulo || "Transmissão Ao Vivo"}
              />

              <div className="absolute top-4 left-4 flex items-center gap-2 bg-red-500 text-white px-3 py-1.5 rounded-full text-sm font-medium pointer-events-none">
                <span className="w-2 h-2 bg-white rounded-full animate-pulse" />
                AO VIVO
              </div>
            </div>

            <div className="p-6 md:p-10 flex flex-col justify-center">
              <div className="flex items-center gap-2 mb-4">
                <span className="w-2 h-2 bg-red-500 rounded-full animate-pulse" />
                <span className="text-red-400 text-sm font-medium">
                  Transmissão ao vivo agora
                </span>
              </div>

              <h2 className="font-serif font-bold text-2xl md:text-3xl text-white leading-tight mb-3">
                {transmissao.titulo || "Ao Vivo"}
              </h2>

              <p className="text-white/70 text-base mb-6 line-clamp-4">
                {transmissao.descricao ||
                  "Acompanhe a transmissão ao vivo da Central Alvinegra."}
              </p>

              <button
                onClick={() => navigate("/ao-vivo")}
                className="bg-white text-alvinegro-black px-6 py-3 rounded-full text-sm font-medium hover:bg-white/90 transition-colors w-fit flex items-center gap-2 cursor-pointer whitespace-nowrap"
              >
                Assistir ao vivo
                <i className="ri-arrow-right-line" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
